import React, { useContext, useEffect, useState } from 'react'
import { BottomDiv, ButtonContainer, ButtonDiv, CloseDiv, Container, DimensionsFieldsDiv, FormData, Header, InputData, InputDiv, InputLabel, SelectData, ShortField, TabDiv, TabsDiv, TabText } from './style'
import { fieldsAndValues } from './utils'
import axios from '../../../config/axios'
import { ServicesContext } from '../../../contexts/ServicesContext'
import close from '../../../assets/close-icon.svg'
import plus from '../../../assets/productions/plus.svg'
import disk from '../../../assets/productions/disk.svg'
import { useNavigate } from 'react-router-dom'
import ModalTest from '../../BaseModal'
import SelectStageInService from '../../ProductionFlow/SelectItem/Stage'
import SelectOrderItemInService from '../../ProductionFlow/SelectItem/OrderItem'
import SelectOrderInService from '../../ProductionFlow/SelectItem/Order'
import { X } from 'lucide-react'

export interface ServiceOfProductionType {
  orderId: number
  orderItem: {id: number, product: string}
  stages: {id: number, name: string}[]
  quantity: number

}

const CreateOPModal:React.FC = () => {
  console.log('🔴🔴🔴 [CreateOPModal] ===== COMPONENTE RENDERIZADO =====')
  console.log('🔴 [CreateOPModal] URL atual:', window.location.href)
  console.log('🔴 [CreateOPModal] Componente renderizado')
  
  const [ service, setService ] = useState<ServiceOfProductionType>({
    orderId: 0,
    orderItem: {id: 0, product: ''},
    stages: [],
    quantity: 0,

  })
  const navigate = useNavigate()

  useEffect(() => {
    console.log('🔴 [CreateOPModal] Service atualizado:', service)
  }, [service])

  const handleSubmitForm = () => {
    console.log('🔴 [CreateOPModal] handleSubmitForm chamado')
    console.log('🔴 [CreateOPModal] Service atual:', service)
    
    const serviceData = {
      orderItemId: service.orderItem.id,
      stages: service.stages.map((s, index) => ({
        stageId: s.id,
        index: index
      })),
      quantity: service.quantity,
    }
    
    console.log('🔴 [CreateOPModal] Dados a serem enviados:', serviceData)
    console.log('🔴 [CreateOPModal] Fazendo POST para:', `${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service`)
    
    axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/production-flow/service`, serviceData)
      .then(response => {
        console.log('✅ [CreateOPModal] Resposta do servidor:', response)
        navigate('../')
        return
      })
      .catch(error => {
        console.error('❌ [CreateOPModal] Erro ao criar serviço:', error)
      })
  }

  console.log('🔴 [CreateOPModal] Renderizando JSX')
  console.log('🔴 [CreateOPModal] Service state:', service)
  
  return(
    <ModalTest>
      <Container>
        <Header>
          <h2>Criar ordem de produção</h2>
          <CloseDiv onClick={() => {
            console.log('🔴 [CreateOPModal] Botão fechar clicado')
            navigate('../')
          }}> <img src={close} /> </CloseDiv>
        </Header>
          <FormData>
            <SelectOrderInService service={service} setService={setService} />
            <SelectOrderItemInService service={service} setService={setService} />
            <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
              <SelectStageInService service={service} setService={setService} />
              <TabsDiv>
                {service.stages.map((s, index) => (
                  <TabDiv key={index}>
                    <TabText>{s.name}</TabText>
                    <X size={16} style={{cursor: 'pointer'}} onClick={() => setService(prev => ({...prev, stages: prev.stages.filter((_, i) => i !== index)}))} />
                  </TabDiv>
                ))}
              </TabsDiv>
            </div>
          </FormData>
          <BottomDiv>
            <ButtonContainer>
              <ButtonDiv onClick={() => {
                console.log('🔴 [CreateOPModal] Botão Cancelar clicado')
                navigate('../')
              }} className='cancel'>Cancelar</ButtonDiv>
              <ButtonDiv onClick={() => {
                console.log('🔴 [CreateOPModal] Botão Cadastrar clicado')
                handleSubmitForm()
              }}>
                <img src={plus} /> Cadastrar
              </ButtonDiv>
            </ButtonContainer>
          </BottomDiv>
      </Container>
    </ModalTest>
  )
}

export default CreateOPModal
